export default __webpack_public_path__ + "static/media/products.6ca50eaf.png";